import styled from "@emotion/styled";

export const LabelStyled = styled.label`
  margin-bottom: 5px !important;
  display: block;
`;
